import React, { Component, PropTypes } from 'react'
import RobotSVG from '../components/RobotSVG'

class LogRecord extends Component {
  handleClick() {
    const { data, loadState } = this.props
    loadState(data)
  }

  renderSolution(){
    const { solution, goalColor } = this.props.data
    // if(!solution || !solution.length){
    //   return <div className = "record-control record-control-solutions">
    //           SOLVING...
    //         </div>
    // }
    // var symbols = [];
    // for(var index = 0; index < solution.length; index=index+2){
    //   symbols.push(<i className= { "fa fa-arrow-" + solution[index+1] + " " + solution[index]}></i>)
    // }
    let arrow
    if(this.props.isActiveRecord){
      arrow = <div className = "arrow"></div>
    }
    return  <div className = "record-control record-control-solutions"> 
              <div className = "arrow-container">
                { arrow }
              </div>
              <RobotSVG fill = { goalColor } />
              <div className = { "solution " + goalColor}>
                { solution ? solution.length/2 : '?' }
              </div>
            </div>
  }

  render() {
    const { boardConfig, goal, goalColor, robotPositions, solution } = this.props.data
    return (
      <div className = "record" onClick = { this.handleClick.bind(this) }>
        { this.renderSolution() }
      </div>
    )
  }
}

LogRecord.propTypes = {

}

export default LogRecord



// WEBPACK FOOTER //
// ./components/LogRecord.js